module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration005sp.3444214f.webp";